import styled from "@emotion/styled";
import React from "react";
import { SVGComponent } from "@typings/svg-component";
import { colors } from "@ui/style/colors";

interface DetailCardProps {
	icon: SVGComponent;
	title: string;
	subtitle: string;
}

export const PatientDetailItem = ({ icon: Icon, title, subtitle }: DetailCardProps): JSX.Element => (
	<Container>
		<Icon width={24} height={24} color={colors.grey} />
		<div>
			<Title className="p-size-s-bold">{title}</Title>
			<div className="p-size-s">{subtitle}</div>
		</div>
	</Container>
);

const Container = styled.div`
	display: flex;
	gap: 8px;
`;

const Title = styled.div`
	color: ${colors.grey};
`;
